import { useState } from 'react';

import { useOktaAuth } from '@okta/okta-react';
import { useIdleTimer } from 'react-idle-timer';

import { settings } from 'config';

import { TimeoutModal } from './TimeoutModal';

export const TimeoutController = (props: { minutes?: number }) => {
  const { oktaAuth } = useOktaAuth();
  const { minutes } = props;
  const [idle, setIdle] = useState(false);

  const signOut = async () => {
    await oktaAuth.signOut({
      clearTokensBeforeRedirect: true,
      postLogoutRedirectUri: settings.APP_ORIGINAL_URI,
      state: 'logged_out',
    });
  };

  const handleOnIdle = () => {
    setIdle(true);
  };

  const { reset } = useIdleTimer({
    timeout: 1000 * (minutes || 60) * 60,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  const handleStillActive = () => {
    setIdle(false);
    reset();
  };

  return idle ? (
    <TimeoutModal
      setStillActive={handleStillActive}
      signOut={signOut}
      timeout={15}
    />
  ) : (
    <div />
  );
};
